/* global femcare */

femcare.general.panelLink = {
    $panelLinks: $('[data-panel-link]'),

    init: function () {
        if (this.$panelLinks.length) {
            // If panel is clicked trigger the corresponding link.
            this.$panelLinks.each(function () {
                
                // Listen to mouse up instead of panel click in order to allow text highlight 
                // Distinguish between click and text highlight by mousedown - up cursor distance moved
                var left = 0,
                    top = 0,
                    radiusLimit = 5;

                $(this).on({
                    mousedown: function (event) {
                        if(event.which === 1){
                            left = event.pageX;
                            top = event.pageY;
                        }                     
                    },
                    mouseup: function (event) {
                        if(event.which === 1){
                            var deltaX = event.pageX - left;
                            var deltaY = event.pageY - top;
                            var euclidean = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                            
                            if (euclidean < radiusLimit) {
                                var $link = $(this).find('a');
                                if ($link.length === 1) {
                                    $link[0].click();
                                }
                            }
                        }
                    }
                });
            });
            
            // Don't propagate link mouse events to panel.
            this.$panelLinks.find('a').on('mousedown', function (e) {
                e.stopPropagation();
            });
            
            this.$panelLinks.find('a').on('mouseup', function (e) {
                e.stopPropagation();
            });
            
            this.$panelLinks.find('a').on('click', function (e) {
                e.stopPropagation();
            });
        }
    }
};
